class UnitizationRecord {
  constructor(data, config) {
    this.typeOfDocument = data.type_of_document
    this.source = data.source
    this.sourceUrl = data.source_url
    this.causeNumber = data.cause_number
    this.orderNumber = data.order_number
    this.state = data.state
    this.applicant = data.applican
    this.unitName = data.unit_name
    this.scanDate = data.scan_date
    this.effectiveDate = data.effective_date
    this.terminationDate = data.termination_date
    this.section = data.section
    this.township = data.township
    this.range = data.range
    this.county = data.county
    this.meridian = data.meridian
    this.description = data.description
    this.tractNumber = data.tract_number
    this.operatorName = data.operator_name
    this.tractAcreage = data.tract_acreage
    this.primaryPercentage = data.primary_percentage
    this.secondaryPercentage = data.secondary_percentage
    this.comment = data.comment
    this.targetReservoir = data.targetReservoir
    this.beginningDepth = data.beginningDepth
    this.endingDepth = data.endingDepth
    this.eur = data.eur
    this.eurMeasurement = data.eurMeasurement
    this.existingWellRecovery = data.existingWellRecovery
    this.currentPsi = data.currentPsi
    this.initialPsi = data.initialPsi
    this.maximumPsi = data.maximumPsi
    this.attachmentUrl = config.unitizationAttachmentEndpoint + data.cause_number
  }
}

export default UnitizationRecord
